import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Tables, Typography, Modal } from '@deeptrue-frontend/ui';
import { RowData } from './IndividualReportsTable';
import { useFormatMessage } from 'components/IntlProvider';
import SingleReport from './SingleReport';

const { TableRow, TableCell } = Tables;

const Link = styled(Typography)`
  color: ${({ theme }) => theme.colors.deepBlue};
  cursor: pointer;
  user-select: none;
`;

const Button = styled.button`
  outline: none;
  border: none;
  background: none;
  white-space: nowrap;
`;

const StyledModal = styled(Modal)`
  max-width: 50rem;
  max-height: 90vh;
  overflow: scroll;
`;

interface Props {
  row: RowData;
  surveyUuid: string;
  organization: string;
  index: number;
}

const IndividualResponse = ({
  row,
  surveyUuid,
  organization,
  index,
}: Props) => {
  const [isReportOpened, setIsReportOpen] = useState(false);

  const t = useFormatMessage();

  return (
    <>
      <StyledModal
        isVisible={isReportOpened}
        onCloseClick={() => setIsReportOpen(false)}
        onBackdropClick={() => setIsReportOpen(false)}
      >
        <SingleReport
          reportId={row.result_id}
          surveyUuid={surveyUuid}
          organization={organization}
          email={row.email}
        />
      </StyledModal>
      <TableRow>
        <TableCell>{index + 1}</TableCell>
        <TableCell>{row.date}</TableCell>
        <TableCell>{row.email}</TableCell>
        <TableCell>{row.overall_satisfaction}</TableCell>
        <TableCell>
          <Button onClick={() => setIsReportOpen(!isReportOpened)}>
            <Link variant="copy2">
              {t(
                'customerSatisfaction.individualTable.cell.viewResponses',
                'View Responses'
              )}
            </Link>
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};

export default IndividualResponse;
